export const ACTORS_DOMAIN = {
  VALUES: 'values',
};

export const ACTORS_DOMAIN_KEY = 'actors';
